import { userWithLoginStatus } from './transformers/user.transformer'
import eventBus from '~/events/eventBus'
import eventDefinitions from '~/events/eventDefinitions'

eventBus.$on(eventDefinitions.USER.LOADED, ({ user }) => {
  const loginStatus = user ? 'logged_in' : 'logged_out'

  if ((loginStatus === 'logged_in' && user.id) || loginStatus === 'logged_out') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'user',
      user_properties: userWithLoginStatus(user, loginStatus),
    })
  }
})
